<template>
  <div>
    <div v-if="showConfirmation">
      <h4 class="new-modal-title mb-3">
        {{ $t('lang.activities.book_confirm_title') }}
      </h4>

      <p class="mb-2">
        {{ $t('lang.activities.book_confirm_text') }}
      </p>

      <div class="col-12 col-md-6 m-auto p-0">
        <img
          src="../../assets/img/illustrations/activities.png"
          width="100%"
        >
      </div>

      <h5 class="mt-2">
        {{ $t('lang.activities.book_confirm_enjoy') }}
      </h5>
    </div>
    <div v-else>
      <div class="row centered-content">
        <div class="col-12 p-0">
          <h4 class="new-modal-title mb-3">
            {{ activity.title }}
          </h4>
        </div>
        <div class="col-12 col-lg-6 mb-3 p-0">
          <img
            class="img-cover"
            :src="activity.image"
            :alt="activity.title"
            :title="activity.title"
          >
        </div>
        <div class="col-12 col-lg-6 m-auto text-left p-0 p-lg-3">
          <p
            class="mb-2"
            v-html="activity.description"
          />

          <div class="d-flex justify-content-between align-items-center mt-3">
            <ReputationIcons
              :score="activity.score/2"
              :reviews="activity.reviews"
            />

            <div>
              <i class=" icon-hourglass-1" />
              {{ activity.duration.duration/60 }} h
            </div>
            <a
              data-toggle="collapse"
              href="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              {{ $t('lang.activities.see_itinerary') }}
            </a>
          </div>

          <div
            id="collapseExample"
            class="collapse"
          >
            <div class="card card-body">
              <p
                class="m-0 long-description"
                v-html="activity.longDescription"
              />
            </div>
          </div>

          <hr class="m-3">
        </div>
      </div>
      <div class="row text-left icon-inputs">
        <div class="col-12 p-0">
          <Errors
            v-if="errors"
            :errors="errors"
          />
        </div>
        <div class="col-12 col-md-6 p-0">
          <h6>{{ $t('lang.transfer.phone') }} <small class="color_text">*</small></h6>
          <PhoneInput @phoneUpdated="updateUserPhone" />
        </div>
        <div class="col-6 col-md-3 p-0 pr-2 pl-md-2 ">
          <h6>{{ $tc('lang.transfer.passengers', 2) }}</h6>
          <div class="form-group">
            <input
              id="pax"
              v-model="pax"
              class="form-control"
              type="number"
              min="1"
              :max="activity.maximumPaxPerActivity"
              style="padding-right: 40px;"
              pattern="\d*"
            >
            <span class="btn-inside-input">
              <button
                type="button"
                @click="paxNumber('minus')"
              >
                <span class="icon-minus" />

              </button>
              <button
                type="button"
                @click="paxNumber('plus')"
              >
                <span class="icon-plus" />
              </button>
            </span>

            <i class="icon-user" />
          </div>
        </div>

        <div class="col-6 col-md-3 p-0 pl-2">
          <h6>Fecha</h6>
          <div class="form-group">
            <input
              id="start_date"
              aria-label="Fecha"
              class="form-control"
              type="text"
              readonly
              style="padding-right: 40px; background-color: white"
              autocomplete="off"
              required
              :placeholder="$t('lang.search.dates.input_placeholder')"
              data-toggle="dropdown"
              :value="inputDate"
              @click="showCalendar=true"
            >
            <i
              class="icon-calendar mr-1"
              @click="showCalendar=true"
            />
          </div>
        </div>

        <div
          v-if="showCalendar"
          class="col-12 col-lg-6 m-auto text-center p-0 p-md-2"
        >
          <v-date-picker
            v-model="selectedDate"
            mode="date"
            hide-time-header
            is24hr
            :locale="$store.state.main.lang"
            :attributes="attributes"
            :min-date="minDate"
            :max-date="maxDate"
            color="pink"
            day-disabled="pointer-events: none"
            :disabled-dates="{ start: null, end: null }"
            :available-dates="availableDates"
            @dayclick="onDayClick"
          />
          <div
            v-if="selectedDate"
            class="text-left d-flex align-items-center justify-content-center mt-2 mb-2"
          >
            <h6 class="mr-3 m-0">
              Hora:
            </h6>
            <div class="btn-group dropup p-0 text-left">
              <button
                id="start-hour"
                type="button"
                class="btn btn-light active dropdown-toggle"
                style="padding: 5px 20px 5px 10px;"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                {{ selectedHour }}h
              </button>
              <div
                class="dropdown-menu pre-scrollable prices-dropdown"
                style="max-height: 300px;"
              >
                <button
                  v-for="hour in hours"
                  :key="'hour_'+hour"
                  class="dropdown-item"
                  type="button"
                  @click="selectedHour = hour"
                >
                  <span :class="[hour===selectedHour ? 'color_text' : '', 'font-weight-bold']">
                    {{ hour }}h
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row centered-content">
        <div class="text-right mb-2 w-100">
          <span><em> {{ $t('lang.activities.price_description') }} </em></span>
        </div>
        <div class="col-12 mt-2 mt-lg-0 p-0">
          <button
            class="btn btn_1 activity-btn full-width mb-0"
            :disabled="buttonDisabled"
            @click="bookActivity"
          >
            <span v-if="buttonDisabled"><i
              class="icon-spin6 animate-spin"
              style="font-size: 130%"
            /></span>
            <span v-else>
              {{ $t('lang.activities.book') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API, errorResponse } from '@/api/api';
import ReputationIcons from './ReputationIcons';
import PhoneInput from '../PhoneInput';
import Errors from '../Alerts/Errors';

const ActivitiesAPI = API.get('activities');
const ShippingAPI = API.get('shipping');

export default {
  name: 'ActivityDetails',
  components: { Errors, PhoneInput, ReputationIcons },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    bookingId: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      selectedDate: null,
      selectedHour: null,
      showCalendar: false,
      pax: 1,
      hours: [],
      userPhone: null,
      errors: {},
      showConfirmation: false,
      buttonDisabled: false,
    };
  },

  computed: {
    attributes() {
      const attrs = [
        {
          highlight: {
            start: { fillMode: 'solid' },
          },
          dates: this.range,
        },
      ];
      return attrs;
    },
    minDate() {
      return `${this.activity.schedule[0].date} 00:00:00`;
    },
    maxDate() {
      const index = this.activity.schedule.length - 1;
      return `${this.activity.schedule[index].date} 00:00:00`;
    },
    availableDates() {
      const daysList = [];
      this.activity.schedule.forEach((schedule) => {
        const day = `${schedule.date} 00:00:00`;
        daysList.push(
          { start: day, end: day },
        );
      });
      return daysList;
    },
    inputDate() {
      let scheduleDay = '';
      let scheduleHour = '';

      if (!this.selectedDate) {
        scheduleDay = this.activity.schedule[0].date;
        scheduleHour = this.activity.schedule[0].times[0].time;
      } else {
        scheduleDay = new Date(this.selectedDate).toISOString().split('T')[0];
        if (this.selectedHour) {
          scheduleHour = this.selectedHour;
        } else {
          scheduleHour = this.activity.schedule.find(
            (data) => data.date === scheduleDay,
          ).times[0].time;
        }
      }
      const lang = window.navigator.language;
      const today = new Date().toISOString().split('T')[0];
      const tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0];

      if (today === scheduleDay) {
        return `${this.$t('lang.search.dates.today')} ${scheduleHour} h`;
      }
      if (tomorrow === scheduleDay) {
        return `${this.$t('lang.search.dates.tomorrow')} ${scheduleHour} h`;
      }
      // agrego los 00:00:00 porque sino cambia de día según el utc.
      const inputValue = `${new Date(`${scheduleDay} 00:00:00`).toLocaleString(lang, {
        day: '2-digit',
        month: '2-digit',
      })} ${scheduleHour} h`;

      return inputValue;
    },
  },
  methods: {
    onDayClick() {
      const daySelected = new Date(this.selectedDate).toISOString().split('T')[0];
      const availableHours = this.activity.schedule.find((data) => data.date === daySelected).times;

      const hoursList = [];
      availableHours.forEach((time) => {
        hoursList.push(time.time);
      });
      this.hours = hoursList;
      this.selectedHour = hoursList[0];
    },
    paxNumber(action) {
      if (action === 'minus') {
        if (this.pax > 1) {
          this.pax--;
        }
      } else if (this.pax < this.activity.maximumPaxPerActivity) {
        this.pax++;
      }
    },
    updateUserPhone(phone) {
      this.userPhone = phone;
    },

    async bookActivity() {
      this.errors = {};
      if (!this.userPhone) {
        this.errors = { data_error: [this.$t('lang.activities.fields_error')] };
      } else {
        const payload = {};

        payload.user = this.userPhone;
        payload.pax = this.pax;
        let date = '';
        if (this.selectedDate) {
          date = new Date(this.selectedDate).toISOString().split('T')[0];
        } else {
          date = this.activity.schedule[0].date;
        }

        if (this.selectedHour) {
          date = `${date} ${this.selectedHour}:00`;
        } else {
          date = `${date} ${this.activity.schedule[0].times[0].time}:00`;
        }
        payload.date_time = date;

        try {
          this.buttonDisabled = true;
          await ActivitiesAPI.confirmActivity(this.activity.id, payload);

          this.showConfirmation = true;
          this.buttonDisabled = false;

          ShippingAPI.shippingServiceRequest({
            booking_id: this.bookingId,
            shipping_service_option: 'book-free-tour',
            address: this.activity.title,
          });
        } catch (error) {
          this.buttonDisabled = false;
          this.errors = errorResponse(error);
        }
      }
    },

  },

};
</script>

<style scoped>

</style>
